import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Pricing.css";

const cars = [
  { id: 1, name: "Seltos",   label: "Kia Seltos",   price: "₹11.12 Lakhs", image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fseltos.avif?alt=media&token=571bd65b-651c-49b3-8ede-e97ed5c0993a",   route: "/seltos" },
  { id: 2, name: "Sonet",    label: "Kia Sonet",    price: "₹8 Lakhs",     image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fsonet.avif?alt=media&token=3e494dad-c44e-4c25-96da-43d4d707a850",    route: "/sonet" },
  { id: 3, name: "Carens",   label: "Kia Carens",   price: "₹10.59 Lakhs", image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fcarens1.avif?alt=media&token=8fa66c98-8f14-4d5d-85d7-312e75f51e9e",  route: "/carens" },
  { id: 4, name: "EV6",      label: "Kia EV6",      price: "₹60.97 Lakhs", image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fev6.avif?alt=media&token=c6f607aa-bdcb-4c22-8f2c-04e5429aade9",      route: "/ev6" },
  { id: 5, name: "Carnival", label: "Kia Carnival", price: "₹63.91 Lakhs", image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fcarnival.avif?alt=media&token=22bfdbc1-1a0e-4a5f-96d4-7a5a468d38ca", route: "/carnival" },
  { id: 6, name: "EV9",      label: "Kia EV9",      price: "₹1.30 Cr",     image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fev9.avif?alt=media&token=8f7f3f13-aae5-4662-a42d-c46c8523f123",      route: "/ev9" },
  { id: 7, name: "Syros",    label: "Kia Syros",    price: "₹8.99 Lakhs",  image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fsuv_syros.avif?alt=media&token=53f06690-20aa-466b-9aad-6720d9868df3", route: "/syros" },
];

const cities = ["Angul","Berhampur","Bhubaneswar","Cuttack","Jajpur","Jharsuguda","Sambalpur"];

const PricePage = (props) => {
  const navigate = useNavigate();
  const [selectedCar, setSelectedCar] = useState(null);
  const [firstName,   setFirstName]   = useState("");
  const [lastName,    setLastName]    = useState("");
  const [email,       setEmail]       = useState("");
  const [mobile,      setMobile]      = useState("");
  const [city,        setCity]        = useState("");
  const [dealership,  setDealership]  = useState("");
  const [pincode,     setPincode]     = useState("");
  const [errors,      setErrors]      = useState({});

  const openModal  = (car) => setSelectedCar(car);
  const closeModal = () => {
    setSelectedCar(null);
    setFirstName(""); setLastName(""); setEmail("");
    setMobile(""); setCity(""); setDealership(""); setPincode("");
    setErrors({});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = {};
    if (!firstName)   errs.firstName   = true;
    if (!mobile)      errs.mobile      = true;
    if (!city)        errs.city        = true;
    if (!pincode)     errs.pincode     = true;
    if (!dealership)  errs.dealership  = true;
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;
    props.getQuotationsRequest(selectedCar.label, firstName, lastName, email, mobile, city, dealership, pincode);
    closeModal();
  };

  return (
    <div className="pr-root">

      {/* ── HERO ── */}
      <section className="pr-hero">
        <div className="pr-hero__bg" />
        <div className="pr-hero__overlay" />
        <div className="pr-hero__content">
          <span className="pr-hero__eyebrow">Central Kia</span>
          <h1 className="pr-hero__title">Kia Pricing &amp;<br />Quotations</h1>
          <p className="pr-hero__desc">
            Transparent, on-road pricing for every Kia model. Click any car to get a personalised quotation instantly.
          </p>
        </div>
      </section>

      {/* ── MODELS SECTION ── */}
      <section className="pr-section">
        <div className="pr-section__inner">

          <div className="pr-section__head">
            <div>
              <span className="pr-section__tag">Our Lineup</span>
              <h2 className="pr-section__title">Choose Your Kia</h2>
            </div>
            <span className="pr-section__count">{cars.length} Models Available</span>
          </div>

          <div className="pr-grid">
            {cars.map((car, i) => (
              <div className="pr-card" key={car.id}>

                {/* image */}
                <div className="pr-card__img-wrap">
                  <img src={car.image} alt={car.label} className="pr-card__img" loading="lazy" decoding="async" />
                  <span className="pr-card__index">0{i + 1}</span>
                  <span className="pr-card__price-tag">Starts at {car.price}</span>
                </div>

                {/* body */}
                <div className="pr-card__body">
                  <div className="pr-card__top">
                    <div className="pr-card__meta">
                      <span className="pr-card__model">{car.name}</span>
                      <h3 className="pr-card__name">{car.label}</h3>
                    </div>
                    <span className="pr-card__price">{car.price}</span>
                  </div>

                  <div className="pr-card__divider" />

                  <div className="pr-card__footer" onClick={() => openModal(car)}>
                    <span className="pr-card__cta-text">Get Quotation</span>
                    <span className="pr-card__arrow">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"/>
                        <polyline points="12 5 19 12 12 19"/>
                      </svg>
                    </span>
                  </div>
                </div>

              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── MODAL ── */}
      {selectedCar && (
        <div className="pr-modal-backdrop" onClick={closeModal}>
          <div className="pr-modal" onClick={(e) => e.stopPropagation()}>

            <div className="pr-modal__head">
              <div>
                <p className="pr-modal__eyebrow">Get Quotation</p>
                <h2 className="pr-modal__title">{selectedCar.label}</h2>
              </div>
              <button className="pr-modal__close" onClick={closeModal} aria-label="Close">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>

            <form onSubmit={handleSubmit} noValidate className="pr-modal__form">
              <div className="pr-field-row">
                <div className="pr-field">
                  <label className="pr-label">First Name <sup className="pr-req">*</sup></label>
                  <input className={`pr-input${errors.firstName ? " pr-input--err" : ""}`}
                    placeholder="First name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                </div>
                <div className="pr-field">
                  <label className="pr-label">Last Name</label>
                  <input className="pr-input" placeholder="Last name" value={lastName}
                    onChange={(e) => setLastName(e.target.value)} />
                </div>
              </div>

              <div className="pr-field-row">
                <div className="pr-field">
                  <label className="pr-label">Mobile No. <sup className="pr-req">*</sup></label>
                  <input className={`pr-input${errors.mobile ? " pr-input--err" : ""}`}
                    placeholder="Mobile number" value={mobile} onChange={(e) => setMobile(e.target.value)} />
                </div>
                <div className="pr-field">
                  <label className="pr-label">Email ID</label>
                  <input className="pr-input" type="email" placeholder="Email (optional)" value={email}
                    onChange={(e) => setEmail(e.target.value)} />
                </div>
              </div>

              <div className="pr-field-row">
                <div className="pr-field">
                  <label className="pr-label">City <sup className="pr-req">*</sup></label>
                  <select className={`pr-select${errors.city ? " pr-input--err" : ""}`}
                    value={city} onChange={(e) => setCity(e.target.value)}>
                    <option value="">Select city</option>
                    {cities.map(c => <option key={c} value={c.toLowerCase()}>{c}</option>)}
                  </select>
                </div>
                <div className="pr-field">
                  <label className="pr-label">Pincode <sup className="pr-req">*</sup></label>
                  <input className={`pr-input${errors.pincode ? " pr-input--err" : ""}`}
                    placeholder="Enter pincode" value={pincode} onChange={(e) => setPincode(e.target.value)} />
                </div>
              </div>

              <div className="pr-field pr-field--full">
                <label className="pr-label">Select Dealership <sup className="pr-req">*</sup></label>
                <select className={`pr-select${errors.dealership ? " pr-input--err" : ""}`}
                  value={dealership} onChange={(e) => setDealership(e.target.value)}>
                  <option value="">Select dealership</option>
                  {cities.map(c => <option key={c} value={c.toLowerCase()}>{c}</option>)}
                </select>
              </div>

              <div className="pr-modal__footer">
                <button type="submit" className="pr-modal__submit">
                  Submit Request &rarr;
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
};

export default PricePage;